import React from 'react';
import _get from 'lodash/get';
import {
  Box,
  Button,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { getResourceName } from 'containers/Series/utils';
import { getSeriesIconByType } from 'containers/Course/utils';
import { CourseRecommendedPaper } from '../course-recommended-paper/CourseRecommendedPaper';
import { TrashIcon } from '../icons/TrashIcon';

const useStyles = makeStyles(theme => ({
  label: {
    ...theme.typography.pRegular,
  },
  button: {
    marginRight: theme.spacing(1),
    borderRadius: '16px !important',
    flexGrow: 1,
  },
  iconButton: {
    padding: theme.spacing(1),
    border: '1px solid #E0E0E0',
  },
}));

export const CourseSavedSeriesResource = ({
  data,
  onRemove,
  goToResource,
  buttonLabel,
}) => {
  const classes = useStyles();
  const series = _get(data, 'series');
  const resource = _get(data, 'resource');
  const module = _get(data, 'module');
  const SeriesTypeIcon = getSeriesIconByType(series);

  return (
    <CourseRecommendedPaper className={classes.root} item={resource}>
      <div>
        <Box mb={2}>
          <Typography color="textPrimary" variant="subtitle2" gutterBottom>
            {getResourceName(resource)}
          </Typography>
          <Typography
            className={classes.label}
            color="textPrimary"
            gutterBottom
          >
            {_get(module, 'fields.title')}
          </Typography>
          <Box display="flex" alignItems="center">
            <Box mr={1}>
              <SeriesTypeIcon size={24} />
            </Box>
            <Typography className={classes.label} color="primary">
              {_get(series, 'fields.title')}
            </Typography>
          </Box>
        </Box>
        <Box display="flex">
          <Button
            color="primary"
            variant="contained"
            className={classes.button}
            onClick={() => goToResource(data)}
          >
            {buttonLabel}
          </Button>
          <IconButton
            className={classes.iconButton}
            onClick={() => onRemove(resource)}
            aria-label="Remove"
          >
            <TrashIcon />
          </IconButton>
        </Box>
      </div>
    </CourseRecommendedPaper>
  );
};
